/**
 * Favorite DTO for use with {@link FavoritesService}
 * @property {string} sku - product SKU
 * @property {number} availableQuantity - available purchase quantity of this item
 * @property {number} backOrderAvailableDate - back-order availability date; null if not on back-order
 * @property {string} market - market
 * @property {number} equinoxListItemId - equinox list item id
 * @property {string} equinoxListId - equinox list id
 */
class Favorite {
    constructor(data = {}) {
        this.sku = data.sku || '';
        this.availableQuantity = data.availableQuantity || 0;
        this.backOrderAvailableDate = data.backOrderAvailableDate || null;
        this.market = data.market || null;
        this.equinoxListItemId = data.listItemId || 0;
        this.equinoxListId = data.listId || 0;
        Object.freeze(this);
    }
}

export default Favorite;
